export default __webpack_public_path__ + "static/media/business-image.0753904f.svg";